module.exports = __webpack_public_path__ + "assets/img/29_295_big.97df9c04.jpg";